import styled from '@emotion/styled';

export const Section = styled.div`
    margin-left: ${({ theme }) => theme.spacing[2]};
`;
